//=include _pages/*
class BreadcrumbScroll {
  constructor(root) {
    this.root = root instanceof Element ? root : document.querySelector(root);

    if (!this.root) {
      return;
    }

    this.track = this.root.querySelector('.c-page-header__breadcrumb-track');

    if (!this.track) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.scrollToStart();
    this.update();
  }

  scrollToStart() {
    this.track.scrollLeft = 0;
  }

  onScroll() {
    this.update();
  }

  onResize() {
    this.scrollToStart();
    this.update();
  }

  update() {
    const { scrollWidth, clientWidth, scrollLeft } = this.track;
    const hasOverflow = scrollWidth > clientWidth + 1;

    this.root.classList.toggle('is-overflow', hasOverflow);
    this.root.classList.toggle('is-left-hidden', hasOverflow && scrollLeft > 1);
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class CustomScrollbar {
  constructor(root) {
    this.root = root instanceof Element ? root : document.querySelector(root);

    if (!this.root || this.root.dataset.customScrollbarInited === '1') {
      return;
    }

    this.setup();
    this.root.dataset.customScrollbarInited = '1';
  }

  setup() {
    let scroll = this.root.querySelector('.c-form-privacy__scroll');

    if (!scroll) {
      scroll = document.createElement('div');
      scroll.className = 'c-form-privacy__scroll';

      while (this.root.firstChild) {
        scroll.appendChild(this.root.firstChild);
      }

      this.root.appendChild(scroll);
    }

    this.scroll = scroll;

    let track = this.root.querySelector('.c-form-privacy__scrollbar');

    if (!track) {
      track = document.createElement('div');
      track.className = 'c-form-privacy__scrollbar';
      track.setAttribute('aria-hidden', 'true');

      const thumb = document.createElement('span');
      thumb.className = 'c-form-privacy__scrollbar-thumb';
      track.appendChild(thumb);

      this.root.appendChild(track);
    }

    this.track = track;
    this.thumb = track.querySelector('.c-form-privacy__scrollbar-thumb');

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.scroll.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.scroll);
    }

    this.update();
  }

  onScroll() {
    this.update();
  }

  onResize() {
    this.update();
  }

  update() {
    const { scrollHeight, clientHeight, scrollTop } = this.scroll;
    const hasOverflow = scrollHeight > clientHeight + 1;

    this.root.classList.toggle('is-scrollable', hasOverflow);
    this.root.classList.toggle('is-at-top', scrollTop <= 1);
    this.root.classList.toggle(
      'is-at-bottom',
      scrollTop + clientHeight >= scrollHeight - 1
    );

    if (!hasOverflow || !this.thumb || !this.track) {
      return;
    }

    if (!window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    const trackHeight = this.track.clientHeight;
    const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 24);
    const maxThumbTop = Math.max(trackHeight - thumbHeight, 0);
    const scrollRatio =
      scrollHeight - clientHeight > 0 ? scrollTop / (scrollHeight - clientHeight) : 0;
    const thumbTop = maxThumbTop * scrollRatio;

    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }
}

class DataCountup {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.targets = Array.from(this.root.querySelectorAll('.js-countup'));
    if (!this.targets.length) {
      return;
    }

    this.isStarted = false;
    this.handleIntersect = this.handleIntersect.bind(this);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        threshold: 0.25,
      });
      this.observer.observe(this.root);
    } else {
      this.start();
    }
  }

  handleIntersect(entries) {
    if (this.isStarted) {
      return;
    }

    const isVisible = entries.some((entry) => entry.isIntersecting);
    if (!isVisible) {
      return;
    }

    this.start();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  start() {
    if (this.isStarted) {
      return;
    }

    this.isStarted = true;
    this.targets.forEach((target) => this.animateTarget(target));
  }

  animateTarget(target) {
    const rawCountTo = target.dataset.countTo;
    const countTo = Number(rawCountTo);
    if (Number.isNaN(countTo)) {
      return;
    }

    const decimalsFromData = Number(target.dataset.countDecimals);
    const decimals = Number.isInteger(decimalsFromData)
      ? decimalsFromData
      : this.detectDecimals(rawCountTo);
    const hasDecimal = decimals > 0;
    const hasComma = target.classList.contains('p-top__data-value-number--has-comma');
    const duration = 1500;
    const startTime = performance.now();

    const update = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = 1 - (1 - progress) ** 3;
      const value = countTo * easedProgress;
      const displayValue = progress === 1 ? countTo : value;

      this.renderValue(target, displayValue, {
        decimals,
        hasDecimal,
        hasComma,
      });

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  }

  detectDecimals(rawValue) {
    if (typeof rawValue !== 'string') {
      return 0;
    }

    const dotIndex = rawValue.indexOf('.');
    if (dotIndex === -1) {
      return 0;
    }

    return rawValue.slice(dotIndex + 1).length;
  }

  renderValue(target, value, { decimals, hasDecimal, hasComma }) {
    const fixedValue = value.toFixed(decimals);
    const [integerPartRaw, decimalPartRaw = ''] = fixedValue.split('.');
    const integerPart = hasComma
      ? Number(integerPartRaw).toLocaleString('ja-JP')
      : integerPartRaw;

    if (hasDecimal) {
      const integerNode = document.createElement('span');
      integerNode.className = 'p-top__data-value-number-integer';
      integerNode.textContent = integerPart;

      const decimalNode = document.createElement('span');
      decimalNode.className = 'p-top__data-value-number-decimal';
      decimalNode.textContent = `.${decimalPartRaw}`;

      target.replaceChildren(integerNode, decimalNode);
      return;
    }

    target.textContent = integerPart;
  }
}

class EnvironmentCharts {
  constructor(selector = '.js-environment-data-inview') {
    this.cards = Array.from(document.querySelectorAll(selector));

    if (!this.cards.length) {
      return;
    }

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.hasChart = typeof Chart !== 'undefined';

    if (this.reducedMotion || !('IntersectionObserver' in window)) {
      this.cards.forEach((card) => this.reveal(card));
    } else {
      this.observe();
    }
  }

  parseNumbers(value) {
    return String(value || '')
      .split(',')
      .map((item) => Number(item.trim()))
      .filter((item) => !Number.isNaN(item));
  }

  observe() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        this.reveal(entry.target);
        this.observer.unobserve(entry.target);
      });
    }, {
      root: null,
      // Android 実機でアドレスバー伸縮時にも発火するよう、中心帯を広めに取る
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0,
    });

    this.cards.forEach((card) => this.observer.observe(card));

    // IntersectionObserver が発火しない端末向けのフォールバック
    window.setTimeout(() => {
      this.cards.forEach((card) => {
        if (!card.classList.contains('is-inview')) {
          this.reveal(card);
        }
      });
    }, 2500);
  }

  reveal(card) {
    if (card.classList.contains('is-inview')) {
      return;
    }

    card.classList.add('is-inview');

    if (!this.hasChart) {
      return;
    }

    card.querySelectorAll('.js-environment-chart').forEach((canvas) => {
      this.createChart(canvas);
    });
  }

  createChart(canvas) {
    if (canvas.dataset.chartInited === '1') {
      return;
    }

    const type = canvas.dataset.chart;
    const prepared = this.preparePie(type, canvas);

    if (!prepared) {
      return;
    }

    canvas.dataset.chartInited = '1';

    const { colors, data } = prepared;
    const startData = this.reducedMotion ? data : data.map(() => 0);
    const chart = new Chart(canvas.getContext('2d'), this.pieConfig(colors, startData, false));

    if (this.reducedMotion) {
      return;
    }

    const play = () => {
      if (!chart.canvas || !chart.canvas.isConnected) {
        return;
      }

      if (!chart.width) {
        chart.resize();
      }

      if (!chart.width) {
        requestAnimationFrame(play);
        return;
      }

      chart.options.animation = this.pieAnimation();
      chart.data.datasets[0].data = data;
      chart.update();
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(play);
    });
  }

  pieAnimation() {
    return {
      animateRotate: true,
      animateScale: false,
      onComplete(animation) {
        const chart = animation.chart;

        if (chart && chart.options) {
          chart.options.animation = false;
        }
      },
    };
  }

  pieOptions(animated) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: animated ? this.pieAnimation() : false,
      events: [],
      layout: {
        autoPadding: false,
        padding: 0,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      rotation: 0,
      radius: '100%',
      elements: {
        arc: {
          borderWidth: 0,
        },
      },
    };
  }

  preparePie(type, canvas) {
    if (type === 'gender') {
      return {
        colors: ['#25A7DE', '#20509A'],
        data: this.parseNumbers(canvas.dataset.chartValues),
      };
    }

    if (type === 'age') {
      return {
        colors: ['#20509A', '#2166AB', '#2491CD', '#25A7DE', '#7DD3F0'],
        data: this.parseNumbers(canvas.dataset.chartValues),
      };
    }

    return null;
  }

  pieConfig(colors, data, animated) {
    return {
      type: 'pie',
      data: {
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 0,
          hoverOffset: 0,
          spacing: 0,
          offset: 0,
        }],
      },
      options: this.pieOptions(animated),
    };
  }
}

class EnvironmentFiguresRoller {
  constructor(selector = '.js-figures-roller') {
    this.targets = Array.from(document.querySelectorAll(selector));

    if (!this.targets.length) {
      return;
    }

    this.duration = 2200;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.targets.forEach((target) => this.setup(target));
  }

  setup(target) {
    if (target.dataset.figuresRollerReady === '1') {
      return;
    }

    const raw = target.dataset.countTo != null
      ? target.dataset.countTo
      : target.textContent.trim();
    const countTo = Number(raw);

    if (Number.isNaN(countTo) || countTo < 0) {
      return;
    }

    const digitLength = Math.max(
      Number(target.dataset.digitLength) || 0,
      String(Math.floor(countTo)).length,
      1
    );

    target.dataset.figuresRollerReady = '1';
    target.setAttribute('aria-label', String(countTo).padStart(digitLength, '0'));
    target.classList.add('is-roller');

    const places = this.buildPlaces(target, countTo, digitLength);
    target._figuresRoller = {
      countTo,
      digitLength,
      places,
      started: false,
    };

    this.setValue(target, 0);

    if (this.reducedMotion) {
      this.setValue(target, countTo);
      return;
    }

    const card = target.closest('.p-environment__figures-card') || target;

    if (!('IntersectionObserver' in window)) {
      this.start(target);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      if (!visible) {
        return;
      }

      this.start(target);
      observer.disconnect();
    }, {
      root: null,
      threshold: 0.35,
    });

    observer.observe(card);
  }

  buildPlaces(target, countTo, digitLength) {
    target.textContent = '';

    const places = [];

    for (let placeIndex = digitLength - 1; placeIndex >= 0; placeIndex -= 1) {
      const divisor = 10 ** placeIndex;
      const maxIndex = Math.floor(countTo / divisor);

      const digit = document.createElement('span');
      digit.className = 'p-environment__figures-digit';
      digit.setAttribute('aria-hidden', 'true');

      const windowEl = document.createElement('span');
      windowEl.className = 'p-environment__figures-digit-window';

      const strip = document.createElement('span');
      strip.className = 'p-environment__figures-digit-strip';

      for (let i = 0; i <= maxIndex; i += 1) {
        const char = document.createElement('span');
        char.className = 'p-environment__figures-digit-char';
        char.textContent = String(i % 10);
        strip.appendChild(char);
      }

      if (!strip.children.length) {
        const char = document.createElement('span');
        char.className = 'p-environment__figures-digit-char';
        char.textContent = '0';
        strip.appendChild(char);
      }

      windowEl.appendChild(strip);
      digit.appendChild(windowEl);
      target.appendChild(digit);

      places.push({ divisor, strip, maxIndex });
    }

    return places;
  }

  setValue(target, value) {
    const state = target._figuresRoller;
    if (!state) {
      return;
    }

    state.places.forEach(({ divisor, strip, maxIndex }) => {
      // 連続位置で流しつつ、ストリップ末尾（整数桁）を超えない。
      // 例: 15 の十の位は 15/10=1.5 になり、1 と空白の間で止まってしまう。
      const index = Math.min(value / divisor, maxIndex);
      strip.style.transform = `translate3d(0, ${(-index).toFixed(4)}em, 0)`;
    });
  }

  easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - ((-2 * t + 2) ** 3) / 2;
  }

  start(target) {
    const state = target._figuresRoller;
    if (!state || state.started) {
      return;
    }

    state.started = true;

    if (state.countTo === 0) {
      this.setValue(target, 0);
      return;
    }

    const startTime = performance.now();

    const update = (now) => {
      const progress = Math.min((now - startTime) / this.duration, 1);
      const eased = this.easeInOutCubic(progress);
      const value = progress === 1
        ? state.countTo
        : state.countTo * eased;

      this.setValue(target, value);

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  }
}

class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderScroll {
  constructor(selector) {
    this.root = document.querySelector(selector);

    if (!this.root) {
      return;
    }

    this.header = this.root.querySelector('.c-header');

    if (!this.header) {
      return;
    }

    this.threshold = 200;
    this.mq = window.matchMedia('(max-width: 767px)');
    this.onScroll = this.onScroll.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    this.mq.addEventListener('change', this.onMediaChange);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.update();
  }

  update() {
    if (!this.mq.matches) {
      this.header.classList.remove('is-scrolled');
      return;
    }

    this.header.classList.toggle('is-scrolled', window.scrollY >= this.threshold);
  }

  onScroll() {
    this.update();
  }

  onMediaChange() {
    this.update();
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InterviewFilter {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.groups = this.root.querySelectorAll('[data-interview-filter-group]');
    this.groups.forEach((group) => {
      this.initGroup(group);
    });
  }

  initGroup(group) {
    const allButton = group.querySelector('[data-filter-all]');
    const items = Array.from(group.querySelectorAll('[data-filter-item]'));

    if (!allButton || !items.length) {
      return;
    }

    const syncAllButton = () => {
      const allChecked = items.every((item) => item.checked);
      allButton.classList.toggle('is-current', allChecked);
    };

    const setAllChecked = (checked) => {
      items.forEach((item) => {
        item.checked = checked;
        const label = item.closest('.p-interview__filter-tag');
        if (label) {
          label.classList.toggle('is-current', checked);
        }
      });
      allButton.classList.toggle('is-current', checked);
    };

    allButton.addEventListener('click', () => {
      const allChecked = items.every((item) => item.checked);
      setAllChecked(!allChecked);
    });

    items.forEach((item) => {
      item.addEventListener('change', () => {
        const label = item.closest('.p-interview__filter-tag');
        if (label) {
          label.classList.toggle('is-current', item.checked);
        }
        syncAllButton();
      });
    });

    syncAllButton();
  }
}

class InterviewSliderSwiper {
  constructor(root) {
    this.root = typeof root === 'string' ? document.querySelector(root) : root;
    this.swiper = null;
    this.onImagesReady = this.onImagesReady.bind(this);
    this.onResize = this.onResize.bind(this);

    if (!this.root || typeof Swiper === 'undefined') {
      return;
    }

    if (!this.shouldUseSwiper(this.getSlideCount())) {
      return;
    }

    this.init();

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 20;
    }

    return window.matchMedia('(max-width: 767px)').matches
      ? rootFontSize * 1.6
      : rootFontSize * 2;
  }

  getSlideCount() {
    const dataCount = parseInt(this.root.dataset.slideCount, 10);

    if (!Number.isNaN(dataCount) && dataCount > 0) {
      return dataCount;
    }

    return this.root.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
  }

  isLoopEnabled() {
    return this.root.dataset.swiperLoop !== 'false';
  }

  isAutoplayEnabled() {
    return this.root.dataset.swiperAutoplay === 'true';
  }

  shouldUseSwiper(slideCount) {
    return slideCount > 5;
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  onResize() {
    if (!this.swiper || this.swiper.destroyed) {
      return;
    }

    this.swiper.params.spaceBetween = this.getSpaceBetweenPx();
    this.swiper.update();
  }

  init() {
    const container = this.root.closest('.c-interview-slider__wrap');
    const prevEl = container ? container.querySelector('.c-interview-slider__control--prev') : null;
    const nextEl = container ? container.querySelector('.c-interview-slider__control--next') : null;
    const slideCount = this.getSlideCount();

    if (!this.shouldUseSwiper(slideCount)) {
      return;
    }

    const useLoop = this.isLoopEnabled();
    const useAutoplay = this.isAutoplayEnabled();

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      spaceBetween: this.getSpaceBetweenPx(),
      loop: useLoop,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
      autoplay: useAutoplay
        ? {
            delay: 4000,
            disableOnInteraction: false,
          }
        : false,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });

    window.addEventListener('resize', this.onResize);
  }
}

class InterviewSwiper {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    this.swiper = null;

    if (!this.root) {
      return;
    }

    this.mq = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
    this.onImagesReady = this.onImagesReady.bind(this);

    this.handleChange();

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.handleChange);
    } else {
      this.mq.addListener(this.handleChange);
    }

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  handleChange() {
    if (this.mq.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 16;
    }

    // SP カード間 gap 16px（Figma）
    return rootFontSize * 1.6;
  }

  init() {
    if (this.swiper) {
      return;
    }
    if (!this.root) {
      return;
    }
    if (typeof Swiper === 'undefined') {
      return;
    }

    const paginationEl = this.root.querySelector('.p-top__interview-pagination');
    const prevEl = this.root.querySelector('.p-top__interview-prev');
    const nextEl = this.root.querySelector('.p-top__interview-next');

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: this.getSpaceBetweenPx(),
      observer: true,
      observeParents: true,
      resistanceRatio: 0,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'fraction',
          }
        : undefined,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });
  }

  destroy() {
    if (!this.swiper) {
      return;
    }

    try {
      // deleteInstance=true / cleanStyles=true（Swiperのバージョン差異対策）
      this.swiper.destroy(true, true);
    } catch (e) {
      this.swiper.destroy();
    }

    this.swiper = null;
  }
}


class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class JobsFilter {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.groups = this.root.querySelectorAll('[data-jobs-filter-group]');
    this.groups.forEach((group) => {
      this.initGroup(group);
    });

    this.root.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitWithoutEmptyParams();
    });

    const resetButton = this.root.querySelector('[data-jobs-filter-reset]');

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        window.location.href = this.root.action;
      });
    }
  }

  submitWithoutEmptyParams() {
    const params = new URLSearchParams();
    const formData = new FormData(this.root);

    formData.forEach((value, key) => {
      const trimmed = String(value).trim();

      if (trimmed !== '') {
        params.append(key, trimmed);
      }
    });

    const query = params.toString();
    const action = this.root.action || window.location.pathname;

    window.location.href = query ? `${action}?${query}` : action;
  }

  initGroup(group) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));

    if (!radios.length) {
      return;
    }

    const syncGroup = () => {
      radios.forEach((radio) => {
        const label = radio.closest('.p-jobs__filter-chip');

        if (label) {
          label.classList.toggle('is-active', radio.checked);
        }
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', syncGroup);
    });

    syncGroup();
  }
}

class MvPhotos {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.photos = this.root.querySelectorAll('.js-p-top-mv-photo');

    if (this.photos.length === 0) {
      return;
    }

    this.run();
  }

  run() {
    gsap.set(this.photos, {
      opacity: 0,
      scale: 1.2,
    });

    const timeline = gsap.timeline({
      defaults: {
        duration: 0.9,
        ease: 'power3.out',
      },
      onComplete: () => {
        this.root.classList.add('is-animated');
        gsap.set(this.photos, { clearProps: 'transform,will-change' });
      },
    });

    timeline.to(this.photos, {
      opacity: 1,
      scale: 1,
      stagger: 0.25,
    });
  }
}

class OccupationPhotoSwiper {
  constructor(root) {
    this.root = typeof root === 'string' ? document.querySelector(root) : root;
    this.swiper = null;

    if (!this.root || typeof Swiper === 'undefined') {
      return;
    }

    this.init();
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 32;
    }

    return window.matchMedia('(max-width: 767px)').matches ? rootFontSize * 1.6 : rootFontSize * 3.2;
  }

  init() {
    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      spaceBetween: this.getSpaceBetweenPx(),
      loop: true,
      speed: 6000,
      allowTouchMove: true,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });

    this.bindRecoveryEvents();
    this.bindTabVisibility();
  }

  bindTabVisibility() {
    const panel = this.root.closest('.c-occupation__day-panel');

    if (!panel) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (panel.classList.contains('is-active')) {
        this.restartAutoplay();
      }
    });

    observer.observe(panel, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  restartAutoplay() {
    if (!this.swiper || this.swiper.destroyed) {
      return;
    }

    this.swiper.update();

    if (this.swiper.autoplay) {
      this.swiper.autoplay.stop();
      this.swiper.autoplay.start();
    }
  }

  bindRecoveryEvents() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.restartAutoplay();
      }
    });

    window.addEventListener('focus', () => {
      if (
        this.swiper &&
        this.swiper.autoplay &&
        (!this.swiper.autoplay.running || this.swiper.autoplay.paused)
      ) {
        this.restartAutoplay();
      }
    });

    window.addEventListener('resize', () => {
      if (!this.swiper || this.swiper.destroyed) {
        return;
      }

      this.swiper.params.spaceBetween = this.getSpaceBetweenPx();
      this.swiper.update();
    });

    // Android 等で autoplay が止まる場合に備え、スワイプ後も再開
    this.root.addEventListener('touchend', () => {
      window.setTimeout(() => this.restartAutoplay(), 300);
    });
  }
}

class PageLoading {
  constructor(selector) {
    this.root = document.querySelector(selector);

    if (!this.root) {
      return;
    }

    this.barFill = this.root.querySelector('.js-page-loading-bar-fill');
    this.startedAt = Date.now();
    this.logoDelay = 200;
    this.logoDuration = 1000;
    this.barGap = 150;
    this.barFillDuration = 2.2;
    this.barCompleteDuration = 0.6;
    this.fadeOutDuration = 800;
    this.barProgress = 0;
    this.isWindowLoaded = document.readyState === 'complete';
    this.isFinished = false;
    this.barStartedAt = null;
    this.barTween = null;
    this.finishTimer = null;

    document.documentElement.classList.add('is-page-loading');
    this.preloadMvImages();
    this.showLogo();
    this.bindLoad();
    this.scheduleSafetyFallback();
  }

  get minDuration() {
    return (
      this.logoDelay +
      this.logoDuration +
      this.barGap +
      this.barFillDuration * 1000 +
      this.barCompleteDuration * 1000 +
      400
    );
  }

  preloadMvImages() {
    const mvRoot = document.querySelector('.js-p-top-mv');

    if (!mvRoot) {
      return;
    }

    const imgs = mvRoot.querySelectorAll('img[src]');
    const sources = Array.from(imgs, (img) => img.currentSrc || img.src).filter(Boolean);

    if (sources.length === 0) {
      return;
    }

    sources.forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }

  showLogo() {
    window.setTimeout(() => {
      this.root.classList.add('is-logo-visible');

      window.setTimeout(() => {
        this.startBarProgress();
      }, this.logoDuration + this.barGap);
    }, this.logoDelay);
  }

  startBarProgress() {
    if (this.barStartedAt) {
      return;
    }

    this.barStartedAt = Date.now();
    this.setBar(0);

    const onBarUpdate = () => {
      this.setBar(this.barProgress);
    };

    this.barTween = gsap.to(this, {
      barProgress: 92,
      duration: this.barFillDuration,
      ease: 'power2.inOut',
      onUpdate: onBarUpdate,
      onComplete: () => {
        if (this.isWindowLoaded) {
          this.completeBar();
        } else {
          this.checkFinish();
        }
      },
    });
  }

  completeBar() {
    if (this.isFinished || this.barProgress >= 99.5) {
      this.checkFinish();
      return;
    }

    if (this.barTween) {
      this.barTween.kill();
      this.barTween = null;
    }

    gsap.to(this, {
      barProgress: 100,
      duration: this.barCompleteDuration,
      ease: 'power2.out',
      onUpdate: () => {
        this.setBar(this.barProgress);
      },
      onComplete: () => {
        this.checkFinish();
      },
    });
  }

  bindLoad() {
    if (this.isWindowLoaded) {
      this.onWindowLoad();
      return;
    }

    window.addEventListener(
      'load',
      () => {
        this.onWindowLoad();
      },
      { once: true }
    );
  }

  onWindowLoad() {
    this.isWindowLoaded = true;

    if (this.barProgress >= 92) {
      this.completeBar();
    }
  }

  scheduleSafetyFallback() {
    window.setTimeout(() => {
      if (this.isFinished) {
        return;
      }

      this.isWindowLoaded = true;

      if (this.barProgress < 99.5) {
        if (this.barTween) {
          this.barTween.kill();
          this.barTween = null;
        }

        gsap.killTweensOf(this);
        this.barProgress = 100;
        this.setBar(100);
      }

      this.checkFinish(true);
    }, 10000);
  }

  setBar(percent) {
    if (!this.barFill) {
      return;
    }

    const value = Math.max(0, Math.min(100, percent)) / 100;
    this.barFill.style.transform = `scaleX(${value})`;
  }

  checkFinish(force = false) {
    if (this.isFinished) {
      return;
    }

    const ready = this.barProgress >= 99.5 && this.isWindowLoaded;

    if (!ready && !force) {
      return;
    }

    const elapsed = Date.now() - this.startedAt;
    const canFinish = force || elapsed >= this.minDuration;

    if (ready && canFinish) {
      this.finish();
      return;
    }

    if (!ready || canFinish) {
      return;
    }

    if (this.finishTimer) {
      return;
    }

    this.finishTimer = window.setTimeout(() => {
      this.finishTimer = null;
      this.checkFinish();
    }, this.minDuration - elapsed + 16);
  }

  finish() {
    if (this.isFinished) {
      return;
    }

    this.isFinished = true;

    if (this.finishTimer) {
      window.clearTimeout(this.finishTimer);
      this.finishTimer = null;
    }

    if (this.barTween) {
      this.barTween.kill();
    }

    gsap.killTweensOf(this);
    this.barProgress = 100;
    this.setBar(100);

    window.setTimeout(() => {
      this.root.classList.add('is-fade-out');

      window.setTimeout(() => {
        this.root.classList.add('is-hidden');
        document.documentElement.classList.remove('is-page-loading');
        $(window).trigger('loading');
      }, this.fadeOutDuration);
    }, 300);
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
const scrollHint = () => {
  new ScrollHint('.js-scroll-hint', {
    i18n: {
      scrollable: 'スクロールできます',
    },
  });
};

class UniversityReservation {
  constructor(rootSelector) {
    this.root =
      typeof rootSelector === 'string'
        ? document.querySelector(rootSelector)
        : rootSelector;

    if (!this.root) {
      return;
    }

    this.limit = Math.max(
      1,
      parseInt(this.root.dataset.selectionLimit || '2', 10) || 2
    );
    this.contactUrl = this.root.dataset.contactUrl || '';
    this.firstParam = this.root.dataset.firstParam || 'session_first';
    this.secondParam = this.root.dataset.secondParam || 'session_second';
    this.applyBtn = this.root.querySelector('.js-university-reservation-apply');
    this.inputs = Array.from(
      this.root.querySelectorAll('.p-university__reservation-input')
    );
    /** チェックした順（第1希望 → 第2希望）。DOM 順ではない。 */
    this.selectionOrder = [];

    this.inputs.forEach((input) => {
      if (input.checked) {
        this.selectionOrder.push(input);
      }

      input.addEventListener('change', () => this.onChange(input));
    });

    this.root.addEventListener('click', (event) => {
      this.handleItemClick(event);
    });

    if (this.applyBtn) {
      this.applyBtn.addEventListener('click', (event) => {
        if (
          this.applyBtn.classList.contains('is-disabled') ||
          this.applyBtn.getAttribute('aria-disabled') === 'true'
        ) {
          event.preventDefault();
        }
      });
    }

    this.sync();
  }

  handleItemClick(event) {
    const item = event.target.closest('.p-university__reservation-item');

    if (
      !(item instanceof HTMLElement) ||
      !this.root.contains(item) ||
      item.classList.contains('is-full') ||
      item.classList.contains('is-limit')
    ) {
      return;
    }

    const input = item.querySelector('.p-university__reservation-input');

    if (!(input instanceof HTMLInputElement) || input.disabled) {
      return;
    }

    // input 自体のクリックはブラウザ標準の change に任せる
    if (event.target === input) {
      return;
    }

    // label は Android で反応しないことがあるため preventDefault して手動トグル
    if (event.target.closest('.p-university__reservation-label')) {
      event.preventDefault();
    }

    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  getCheckedInOrder() {
    return this.selectionOrder.filter((input) => input.checked);
  }

  onChange(input) {
    if (input.checked) {
      if (this.selectionOrder.length >= this.limit) {
        input.checked = false;
        return;
      }

      if (!this.selectionOrder.includes(input)) {
        this.selectionOrder.push(input);
      }
    } else {
      this.selectionOrder = this.selectionOrder.filter((item) => item !== input);
    }

    this.sync();
  }

  sync() {
    this.selectionOrder = this.getCheckedInOrder();
    const checked = this.selectionOrder;
    const atLimit = checked.length >= this.limit;

    this.inputs.forEach((input) => {
      const item = input.closest('.p-university__reservation-item');
      const status = item
        ? item.querySelector('.p-university__reservation-status')
        : null;
      const order = checked.indexOf(input);
      const isSelected = order >= 0;

      if (item) {
        item.classList.toggle('is-limit', !isSelected && atLimit);
      }

      if (isSelected) {
        input.disabled = false;
        if (status) {
          status.hidden = false;
          status.textContent = order === 0 ? '第1希望' : '第2希望';
        }
        return;
      }

      if (atLimit) {
        input.disabled = true;
        if (status) {
          status.hidden = false;
          status.innerHTML = '上限数に<br>達しています';
        }
        return;
      }

      input.disabled = false;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
    });

    if (!this.applyBtn) {
      return;
    }

    if (checked.length === 0 || !this.contactUrl) {
      this.applyBtn.href = this.contactUrl || '#';
      this.applyBtn.classList.add('is-disabled');
      this.applyBtn.setAttribute('aria-disabled', 'true');
      this.applyBtn.setAttribute('tabindex', '-1');
      return;
    }

    const url = new URL(this.contactUrl, window.location.origin);
    url.searchParams.set(this.firstParam, checked[0].value);

    if (checked[1]) {
      url.searchParams.set(this.secondParam, checked[1].value);
    } else {
      url.searchParams.delete(this.secondParam);
    }

    this.applyBtn.href = url.toString();
    this.applyBtn.classList.remove('is-disabled');
    this.applyBtn.setAttribute('aria-disabled', 'false');
    this.applyBtn.removeAttribute('tabindex');
  }
}

class WorkSwiper {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    this.swiper = null;

    if (!this.root) {
      return;
    }

    this.mq = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
    this.onImagesReady = this.onImagesReady.bind(this);

    this.handleChange();

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.handleChange);
    } else {
      this.mq.addListener(this.handleChange);
    }

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  handleChange() {
    if (this.mq.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 12;
    }

    // SP カード間 gap 12px（Figma node 8704:3305）
    return rootFontSize * 1.2;
  }

  init() {
    if (this.swiper) {
      return;
    }
    if (!this.root) {
      return;
    }
    if (typeof Swiper === 'undefined') {
      return;
    }

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: this.getSpaceBetweenPx(),
      loop: true,
      observer: true,
      observeParents: true,
      resistanceRatio: 0,
      allowTouchMove: true,
      touchStartPreventDefault: false,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });
  }

  destroy() {
    if (!this.swiper) {
      return;
    }

    try {
      this.swiper.destroy(true, true);
    } catch (e) {
      this.swiper.destroy();
    }

    this.swiper = null;
  }
}


(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
})();

let pageLoadingHooksRan = false;

const initInterviewSliders = () => {
  document.querySelectorAll('.js-interview-slider').forEach((el) => {
    if (el.dataset.interviewSliderInited === '1') {
      return;
    }

    new InterviewSliderSwiper(el);
    el.dataset.interviewSliderInited = '1';
  });
};

const runPageLoadingHooks = () => {
  if (pageLoadingHooksRan) {
    return;
  }

  pageLoadingHooksRan = true;

  if (document.querySelector('.js-p-top-mv')) {
    new MvPhotos('.js-p-top-mv');
  }

  if (document.querySelector('.p-top__interview-slider')) {
    new InterviewSwiper('.p-top__interview-slider');
  }

  if (document.querySelector('.p-top__work-slider')) {
    new WorkSwiper('.p-top__work-slider');
  }

  document.querySelectorAll('.js-occupation-photo-slider').forEach((el) => {
    new OccupationPhotoSwiper(el);
  });

  initInterviewSliders();

  if (document.querySelector('.p-top__data')) {
    new DataCountup('.p-top__data');
  }

  document.querySelectorAll('.js-breadcrumb-scroll').forEach((el) => {
    new BreadcrumbScroll(el);
  });

  document.querySelectorAll('.c-form-privacy__box').forEach((el) => {
    new CustomScrollbar(el);
  });

  if (document.querySelector('.js-interview-filter')) {
    new InterviewFilter('.js-interview-filter');
  }

  if (document.querySelector('.js-jobs-filter')) {
    new JobsFilter('.js-jobs-filter');
  }

  if (document.querySelector('.js-university-reservation')) {
    new UniversityReservation('.js-university-reservation');
  }

  if (document.querySelector('.js-figures-roller')) {
    new EnvironmentFiguresRoller();
  }

  if (document.querySelector('.js-environment-data-inview')) {
    new EnvironmentCharts();
  }

  const scrollHintEl = document.querySelector('.js-scroll-hint');
  scrollHintEl && scrollHint();
};

//DOMContentLoaded
$(() => {
  initInterviewSliders();

  if (document.querySelector('.js-header')) {
    new HeaderScroll('.js-header');
  }

  const $pageTopButton = $('.js-page-top');

  if ($pageTopButton.length) {
    $pageTopButton.on('click', () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
  }

  if (document.querySelector('.js-page-loading')) {
    new PageLoading('.js-page-loading');
  } else {
    $(window).on('load', () => {
      $(window).trigger('loading');
    });

    if (document.readyState === 'complete') {
      runPageLoadingHooks();
    }
  }
});

//after loading animation
$(window).on('loading', runPageLoadingHooks);
